<template>
        <div class="animated fadeIn">
            <spinner v-if="loading"/>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Search Outstanding Orders</strong>
                        </div>
                        <b-row>
                            <b-col sm="3">
                                <b-form-group>
                                    <label for="country">Country</label>
                                        <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country"/>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <label for="country">Location</label>
                                <warehouseLookup v-bind:url="apiWarehouseLookup" v-on:selected="setWarehouse($event)" :lookupId="filter.warehouse" :q2="filter.country"/>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group>
                                    <label>Transaction Date</label>
                                    <b-form-input type="date" v-model="filter.invoice_date"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group>
                                    <label>Invoice No</label>
                                    <b-form-input type="text" v-model="filter.invoice_number"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div slot="footer">
                            <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="searchResults.length >0 && !loading">
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Outstanding Orders</strong>
                        </div>
                        <b-row>
                            <b-col sm="12">
                                <div class="table-responsive">
                                    <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :items="searchResults"
                                    :per-page="perPage" :current-page="currentPage"></b-table>
                                </div>
                                <nav>
                                    <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                                </nav>
                            </b-col>
                        </b-row>
                        <div slot="footer">
                            <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data = "searchResults" :fields = "exportHeaders" name = "undelivered_orders.xls">
                                Export to Excel
                            </exportExcel>
                            <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-else-if="noResults && !loading" >
                <b-col sm="12">
                    <div align="center">
                    <strong>No Records Found</strong>
                    </div>                    
                </b-col>
            </b-row>
        </div>
    </template>
    <script>
    import axios from 'axios'
    import spinner from '@/components/Spinner.vue'
    import countryLookup from '@/components/Autocomplete.vue'
    import warehouseLookup from '@/components/Autocomplete.vue'
    import {authHeader, apiCountryLookup,apiWarehouseLookup,apiPodUpdate,apiPodSearch,apiOutstandingOrdersSearch} from '@/functions/common.vue'
    import exportExcel from 'vue-json-excel'
    
    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        "ukai": {
            normal: 'ukai.ttf',
            bold: 'ukai.ttf',
            italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
        },
    };
    export default
    {
        components:{spinner,countryLookup,warehouseLookup,exportExcel},
        props: 
        {
          caption: 
          {
            type: String,
            default: 'Table'
          },
          hover: 
          {
            type: Boolean,
            default: false
          },
          striped: 
          {
            type: Boolean,
            default: false
          },
          bordered: 
          {
            type: Boolean,
            default: false
          },
          small: 
          {
            type: Boolean,
            default: false
          },
          fixed: 
          {
            type: Boolean,
            default: false
          }
        },
        data()
        {
            return{
                loading:false,
                apiCountryLookup:apiCountryLookup,
                apiWarehouseLookup:apiWarehouseLookup,
                filter: 
                {
                    country: '',
                    warehouse:'',
                    invoice_date: '',
                    invoice_number:'',
                },  
                exportHeaders:
                {
                    'Country': 'country',
                    'Location': 'warehouse',
                    'Trans Type': 'transaction_type',
                    'Invoice Date':'invoice_date',
                    'Sales Doc #':'invoice_number',
                    'Tax Invoice #':'tax_invoice_number',
                    'Delivery Method':'delivery_method',
                    'Member':'member',
                    'SKU':'sku',
                    'Description':'description',
                    'Qty':'qty',
                    'Total DP':'total_dp',
                    'Delivery Status':'delivery_status'
                }, 
                searchResults: [],
                searchResultsFields: 
                [
                    {key: 'country', label: 'Country'},
                    {key: 'warehouse', label: 'Warehouse'},
                    {key: 'transaction_type', label: 'Trans Type'},
                    {key: 'invoice_date', label: 'Invoice Date'},
                    {key: 'invoice_number', label: 'Sales Doc #'},
                    {key: 'tax_invoice_number', label: 'Tax Invoice #'},
                    {key: 'delivery_method', label: 'Delivery Method'},
                    {key: 'member', label: 'Member'},
                    {key: 'sku', label: 'SKU'},
                    {key: 'description', label: 'Description'},
                    {key: 'qty', label: 'Qty'},
                    {key: 'total_dp', label: 'Total DP'},
                    {key: 'delivery_status', label: 'Delivery Status'}
                ],
                currentPage: 1,
                perPage: 30,
                totalRows: 0,
                noResults: false
                }
        },
        methods:
        {
        print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push([
          'Country',
          'Location',
          'Trans Type',
          'Invoice Date',
          'Invoice #',
          'Delivery Method',
          'Member',
          'SKU',
          'Description',
          'Qty',
          'Total DP',
          'Delivery Status'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [data.country,data.warehouse,data.transaction_type,data.invoice_date,data.invoice_number,data.delivery_method,data.member,data.sku,data.description,data.qty,data.total_dp,data.delivery_status]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'Stock Un-Delivered Report generated on'+ " "+ date, margin: [ 5, 7, 10, 30 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',
          
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
                font: 'ukai'
            },
            content: [
              {
                fontSize: 7.5,
                layout: 'lightHorizontalLines', // optional
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto'],
                  body: 
                    rows
                  
                }
              }
            ]
          };

          pdfMake.createPdf(dd).open();
        },
            search()
            {
                // alert("A")
                var sf =
                [
                    "country = " + this.filter.country
                    ,"warehouse = " + this.filter.warehouse
                    ,"invoice_date = " + this.filter.invoice_date
                    ,"invoice_number LIKE " + this.filter.invoice_number
                     ,"delivery_status = " + "PENDING"
                    // ,"trans_type <> " + "do"
                ]   


                //console.log(sf)
                this.loading = true
                axios.post(apiOutstandingOrdersSearch, sf,authHeader())
                .then (res => 
                {
                    return res
                })
                .then (data =>
                {
                    this.loading = false
                    var myData = data.data.data
                    for ( var d in myData)
                    {
                        var date = myData[d].invoice_date
                        var date = new Date(date);
                        var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                        myData[d].invoice_date = result
                        
                        if (myData[d].total_dp == "")
                        {
                            myData[d].total_dp = "-"
                        }

                        if (myData[d].transaction_type == "")
                        {
                            myData[d].transaction_type = "-"
                        }

                        if(myData[d].tax_invoice_number == null)
                        {
                            myData[d].tax_invoice_number = "-"
                        }
                    }
                    this.searchResults = myData

                    if(this.searchResults.length == 0)
                    {
                        this.noResults = true
                        this.loading = false
                    }
                    
                })
                .catch(error => alert(error))
    
            },
            setCountry(obj)
            {
                var id
    
                    if (obj !== null)
                    {
                        id = obj.id
                    } 
                    else
                    {
                        id = ""
                    }
                this.filter.country = id
            },
            setWarehouse(obj)
            {
                var id
    
                    if (obj !== null)
                    {
                        id = obj.id
                    } 
                    else
                    {
                        id = ""
                    }
                this.filter.warehouse = id
            },
            getRowCount (items) 
            {
                return items.length
            },
        }
    }
    </script>


// WEBPACK FOOTER //
// src/views/reports/pur.vue